import React from 'react'

const Loader = () => {
    return (
        <div className="progress green darken-4">
            <div className="indeterminate green">

            </div>
        </div>
    )
}

export default Loader